// Wer erscheint im internen Chat?
//
// Vorher stand JEDES Profil in der Kollegenliste — auch Mieter und Eigentümer mit
// Portalzugang (Vorfall 17.08.2026: „Max Muster" als Eigentümer, „Max Mustermann" als
// Mieter). Die Regel steht hier als reine Funktion, weil sie zweimal gilt: für die
// Kollegenliste im Frontend UND wortgleich in der Schreib-Policy chat_senden.
//
// Die Rollenliste ist absichtlich dieselbe wie in is_staff() — laufen die beiden
// auseinander, zeigt die Liste jemanden, dem die Datenbank das Schreiben verweigert.
export const CHAT_ROLLEN = ['admin', 'super admin', 'master admin', 'team'] as const;

export interface ChatProfil {
  role?: string | null;
  status?: string | null;
  /** false = kein Belegschaftsmitglied (Entwickler-/Zweitkonto), siehe profiles.ist_angestellt. */
  ist_angestellt?: boolean | null;
}

export function nimmtAmChatTeil(p: ChatProfil): boolean {
  const rolle = (p.role || '').trim().toLowerCase();
  if (!(CHAT_ROLLEN as readonly string[]).includes(rolle)) return false;
  // Standard ist Belegschaft — nur ein ausdrückliches false schließt aus.
  if (p.ist_angestellt === false) return false;
  // Inaktive und archivierte Mitarbeiter (#516) nehmen nicht teil
  const status = (p.status || 'aktiv').trim().toLowerCase();
  return status !== 'inaktiv' && status !== 'archiviert';
}
